import "./MFA.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import email_icon from "../../Assets/email.png";
import phone_icon from "../../Assets/phone.png";
import { useState } from "react";
import MfaModal from "../../components/MfaModal";
import { Constants } from "../../constants/constants";
import { UserProfileResponse } from "../../models/UserProfileResponse";
import { MfaSetupReponse } from "../../models/MfaSetupResponse";
import { confirmMfaAsync, postMfaEnableAsync } from "../../api/AccountApi";
import { ResponseMessage } from "../../models/ResponseMessage";

const MFA: React.FC = () => {
  const [selectMfa, setSelectMfa] = useState("none");
  const [showModalMfa, setShowModalMfa] = useState(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [user, setUser] = useState<UserProfileResponse | null>(null);
  const token = localStorage.getItem(Constants.ACCESS_TOKEN) ?? "";
  const userInfo = localStorage.getItem(Constants.USER_INFO);
  const navigate = useNavigate();
  const [qrCodeImage, setQrCodeImage] = useState("");
  const [mfaCode, setMfaCode] = useState("");

  const callForMfa = async () => {
    try {
      const response: ResponseMessage<MfaSetupReponse> =
        await postMfaEnableAsync(token);
      if (response.success) {
        setQrCodeImage(response.result.qrCodeImage);
        setShowModalMfa(true);
      }
    } catch {}
  };

  const afterVerify = async () => {
    try {
      const response: ResponseMessage<boolean> = await confirmMfaAsync(
        token,
        mfaCode
      );
      if (response.success) {
      }
    } catch {}
  };

  useEffect(() => {
    if (!userInfo || !token || token === "") {
      window.location.href = "/login";
    } else {
      setUser(JSON.parse(userInfo));
    }
  }, []);

  return (
    <div className="main_content_mfa">
      <div className="holder_mfa_setting">
        <button
          type="button"
          className="mfa-back"
          onClick={() => navigate(-1)}
        >
          ← Back
        </button>
        <label className="mfa_title">Two-Factor Authentication</label>
        <label className="mfa_des">
          2FA is required to protect your account. How would you like to receive
          one-time passwords(OTPs)
        </label>
        <div className="select-area">
          <div
            className={`select_mfa ${selectMfa === "email" ? "selected" : ""}`}
            onClick={() => {
              setSelectMfa("email");
            }}
          >
            <img src={email_icon}></img>
            <label>Email Authentication</label>
          </div>
          <div
            className={`select_mfa ${selectMfa === "phone" ? "selected" : ""}`}
            onClick={() => {
              setSelectMfa("phone");
            }}
          >
            <img src={phone_icon}></img>
            <label>Phone Authentication</label>
          </div>
          <div
            className={`select_mfa ${
              selectMfa === "authenticator" ? "selected" : ""
            }`}
            onClick={() => {
              setSelectMfa("authenticator");
            }}
          >
            <img src={phone_icon}></img>
            <label>Authenticator Authentication</label>
          </div>

          <button
            className="selected_btn"
            disabled={selectMfa === "none"}
            onClick={callForMfa}
          >
            Continue
          </button>
        </div>
      </div>
      <MfaModal show={showModalMfa} btnName="Save" onSave={() => afterVerify()}>
        <h2>Please select {selectMfa.toUpperCase()}</h2>

        {selectMfa === "email" && (
          <p>Your email : {user?.email} will be used as 2FA. </p>
        )}
        {selectMfa === "phone" && (
          <div className="mfa_modal_input_wrapper">
            <p>Your contact no : {user?.contact} will be used as 2FA. </p>
          </div>
        )}
        {selectMfa === "authenticator" && (
          <div className="mfa_modal_image">
            <input
              className="input_mfa"
              placeholder="Enter Code"
              value={mfaCode}
              onChange={(e) => setMfaCode(e.target.value)}
            />
            <p>Please scan this image from your authenricator app</p>
            <img className="qr" src={qrCodeImage} alt="MFA QR code"></img>
          </div>
        )}
      </MfaModal>
    </div>
  );
};

export default MFA;
